import * as React from 'react';
import clsx from 'clsx';

import { generateAriaProps } from './inputHelpers';
import IconRadiobuttonChecked from '../components/icons/svgr/IconRadiobuttonChecked';
import IconRadiobuttonUnchecked from '../components/icons/svgr/IconRadiobuttonUnchecked';

export interface RadiobuttonInputProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  hasError?: boolean;
  error?: string | object;
  hint?: string;
  label: string;
  name?: string;
  id?: string;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onFocus?(event: React.FocusEvent<HTMLInputElement>): void;
}

/**
 * @deprecated
 * Plase see ui folder of your project
 */
export const Radiobutton = React.memo(
  ({
    checked,
    className,
    disabled,
    error,
    hasError,
    hint,
    label,
    id,
    name,
    ...restProps
  }: RadiobuttonInputProps) => {
    const componentClassName = clsx('RadioButton', className, {
      'is-checked': checked,
      'is-disabled': disabled,
    });

    const ariaProps = generateAriaProps({
      hasError,
      label,
      name,
      hint,
    });

    return (
      <>
        <label htmlFor={id} className={componentClassName}>
          <input
            className="Input RadioButton-input"
            {...restProps}
            {...ariaProps}
            id={id}
            name={name}
            value={id}
            type="radio"
            checked={checked}
            aria-checked={checked}
          />
          <div className="RadioButton-indicator">
            <div aria-hidden role="radio" aria-checked={checked}>
              {checked && <IconRadiobuttonChecked className="RadioButton-icon" />}
              {!checked && <IconRadiobuttonUnchecked className="RadioButton-icon" />}
            </div>
            <span className="RadioButton-label">{label}</span>
          </div>
        </label>
        {hint && (
          <div className="Hints">
            <div className="Hint">{hint}</div>
          </div>
        )}
      </>
    );
  }
);
